import React, {useEffect, useState} from "react"
import axios, { Axios } from 'axios'

export default function RestorePassword() {
    const [passwordReg1, setPasswordReg1] = useState('')
    const [passwordReg2, setPasswordReg2] = useState('')
    const [passwordReg3, setPasswordReg3] = useState('')
    const [passwordError2, setPasswordError2] = useState('');
    const [passwordError3, setPasswordError3] = useState('');

    const [alertState, setAlertState] = useState(0)
    const [alertStateWrong, setAlertStateWrong] = useState(0)
    const [description, setDescription] = useState('')

    const [verificationStatus, setVerificationStatus] = useState('Verifying email...');
    const [verificationStatusState, setVerificationStatusState] = useState(0);

    useEffect(() => {
        verifyEmail();
      }, []);
    
      const verifyEmail = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
      
        if (!code) {
          throw new Error('Verification code not found');
        }
      
        //console.log('Verification code:', code);
      
        const url = `${process.env.REACT_APP_BACKEND}/api/verify-email-change-password?code=${code}`;
        //console.log('Request URL:', url);
      
        axios.get(url)
          .then((response) => {
            if (response.data && response.data.success) {
              setVerificationStatus('Email was successfully verified!');
              setVerificationStatusState(0)
            } else {
              throw new Error(response.data.error || 'An error occurred while verifying email');
            }
          })
          .catch((error) => {
            console.error('Error verifying email:', error);
            setVerificationStatus('An error occurred while verifying email');
            setVerificationStatusState(1)
          });
      };

    const validatePassword2 = (value) => {
        if (value.length > 30) {
            setPasswordError2('Password must be maximum 30 characters long');
            return false; // Password longer than 30 characters
        } else if (value.includes('Password cannot be empty')) {
            setPasswordError2('Password cannot contain spaces');
            return false;
        } else if (value.length < 8) {
            setPasswordError2('Password must be at least 8 characters long');
            return false;
        } else {
            setPasswordError2('');
            return true;
        }
    };

    const validatePassword3 = (value) => {
        if (value.length > 30) {
            setPasswordError3('Password must be maximum 30 characters long');
            return false; // Password longer than 30 characters
        } else if (value.includes(' ')) {
            setPasswordError3('Password cannot contain spaces');
            return false;
        } else if (value.length < 8) {
            setPasswordError3('Password must be at least 8 characters long');
            return false;
        } else {
            setPasswordError3('');
            return true;
        }
    };

    const changePasswordFunction =() => {

        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        
        axios.post(`${process.env.REACT_APP_BACKEND}/resetPassword`, {
            codeFromLink: code,
            passwordNew: passwordReg2,
            passwordNewRepeat: passwordReg3
        }).then((response) => {
            //alert(response.data.message)

            setAlertState(1);
            const descr = response.data.message
            setDescription(descr)
        }).catch((err) => {
            //alert(JSON.stringify(err.response.data.message))

            setAlertStateWrong(1);
            const descrWrong = err.response.data.message
            setDescription(descrWrong)
        })
      }

      const closeAlert =() => {
        setAlertState(0)
        setAlertStateWrong(0)
        setDescription('')
    }

    const linkToLogin =() => {
        window.location.href = `${process.env.REACT_APP_BACKEND_TWO}/register`;
      }
      
    return (
        <div className="changePasswordPage">
            {verificationStatusState === 0 ?
             <form className="formAccountChangePassword2">  

            <div className="changeEmailFormColumn">
                <label className="labelChangePassword2">New password</label>

                <input type="password" className="buttonFormChangePassword"
                 onChange={(e) => {
                    setPasswordReg2(e.target.value)
                    validatePassword2(e.target.value);
                }}/>
                {passwordError2 && <span className="errorChangeEmail">{passwordError2}</span>}
            </div>

            <div className="changeEmailFormColumn">
                <label className="labelChangePassword">Repeat new password</label>

                <input type="password" className="buttonFormChangePassword"
                 onChange={(e) => {
                    setPasswordReg3(e.target.value)
                    validatePassword3(e.target.value);
                }}/>
                {passwordError3 && <span className="errorChangeEmail">{passwordError3}</span>}
            </div>

                <button type="button" onClick={() => {changePasswordFunction()}} className="buttonFormSubmitChangeEmail" disabled={passwordError2 || passwordError3}>Change password</button>
                <div className="buttonBackToLoginPage" onClick={() => {linkToLogin()}}>Back to login page</div>
            </form>

            : 
            <div className="verifyPage">
            <div className="verifyPageTextBlack">Invalid password reset link</div>
            </div>
            }

            <div className={alertState ? 'alertDiv' : 'notDisplayed' }>
  
            <div className="alertDiv-content">
                <i className="check">

                <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 24 24" fill="none">
                <path d="M4.89163 13.2687L9.16582 17.5427L18.7085 8" stroke="#ffffff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path xmlns="http://www.w3.org/2000/svg" d="M4.89163 13.2687L9.16582 17.5427L18.7085 8" stroke="#ffffff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                </i>

                <div className="messageDiv">
                <span className="textDiv textDiv-1">Success</span>
                <span className="textDiv textDiv-2">{description}</span>
                </div>
            </div>
            <button className="close" onClick={() => {closeAlert()}}>X</button>

            </div>

            <div className={alertStateWrong ? 'alertDiv' : 'notDisplayed' }>

            <div className="alertDiv-content">
                <i className="checkWrong">

                <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 24 24" fill="none">
                <path d="M6 12L18 12" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                </i>

                <div className="messageDivWrong">
                <span className="textDiv textDiv-2">{description}</span>
                </div>
            </div>
            <button className="close" onClick={() => {closeAlert()}}>X</button>

            </div>
        </div>
    )
}